// @ flow
import * as React from "react";
import styled from "styled-components";
import Label from "../label";
import PropTypes from 'prop-types';

const mapValidationToColor = ({ value, isValid }) => {
  if (typeof isValid !== 'boolean' || !value) return '#e7e6e6';
  return isValid ? '#3dcd58' : '#c4124d';
};

const InputContainer = styled.div`
`;
const InputField = styled.input`
  width: calc(100% - 17px);
  padding: 8.5px;
  border: 1px solid ${mapValidationToColor};
`;

class Input extends React.PureComponent {

  static propTypes = {
    label: PropTypes.object,
  }

  get inputProps() {
    return {
      ...this.props,
      label: null,
  };
  }

  render() {
    return (
      <InputContainer>
        <Label>{this.props.label}</Label>
        <InputField {...this.inputProps}/>
      </InputContainer>
    );
  }
}

export default Input;
